import {
  Car,
  Sun,
  LayoutGrid,
  Footprints,
  Layers,
  SquareStack,
  Wrench,
  Sparkles,
  Snowflake,
  ShieldCheck,
  BadgeCheck,
  CalendarCheck,
  HardHat,
  Home,
  MapPin,
  type LucideIcon,
} from "lucide-react";

const REGISTRY: Record<string, LucideIcon> = {
  car: Car,
  sun: Sun,
  "layout-grid": LayoutGrid,
  footprints: Footprints,
  layers: Layers,
  "square-stack": SquareStack,
  wrench: Wrench,
  sparkles: Sparkles,
  snowflake: Snowflake,
  "shield-check": ShieldCheck,
  "badge-check": BadgeCheck,
  "calendar-check": CalendarCheck,
  "hard-hat": HardHat,
  home: Home,
  "map-pin": MapPin,
};

export function Icon({ name, className }: { name: string; className?: string }) {
  const Cmp = REGISTRY[name] ?? Sparkles;
  return <Cmp className={className} />;
}
